import type { BookedFlightItineraryWithDepartureTime } from "@b2bportal/air-booking-api";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PriceBreakdown as CorePriceBreakdown } from "@tenant/ui";
import clsx from "clsx";
import styles from "./FlightTripDetailPriceBreakdown.module.scss";
import { useFlightTripDetailPriceBreakdown } from "./useFlightTripDetailPriceBreakdown";

interface FlightTripDetailPriceBreakdownProps {
  itinerary: BookedFlightItineraryWithDepartureTime;
  className?: string;
}

export const FlightTripDetailPriceBreakdown = ({
  itinerary,
  className,
}: FlightTripDetailPriceBreakdownProps) => {
  const [block, cn] = useModuleBEM(styles, "FlightTripDetailPriceBreakdown");
  const { t } = useI18nContext();

  const { priceLineItems, summaryLineItems, amountDue, paymentMethodDisplay } =
    useFlightTripDetailPriceBreakdown(itinerary);

  return (
    <div className={clsx(block, className)}>
      <h3 className={cn("title")}>{t("priceDetails")}</h3>
      <CorePriceBreakdown
        isLoading={false}
        priceLineItems={priceLineItems}
        summaryLineItems={summaryLineItems}
      />
      <div className={cn("container")}>
        <div className={cn("row", ["bold"])}>
          <span>{t("trips.amountPaid")}</span>
          <span>{amountDue}</span>
        </div>
        {paymentMethodDisplay && (
          <div className={cn("row")}>
            <div className={cn("summary-item-label")}>
              {t("trips.paymentMethod")}
            </div>
            <div className={cn("summary-item-value")}>
              {paymentMethodDisplay}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
